import type ArtifactResource from "~/client/resources/artifactResource";
import type { Client } from "../client";
import type { ListArgs } from "./basicRepository";
import BasicRepository from "./basicRepository";

type ArtifactListArgs = {
    regarding?: string;
    order?: string;
} & ListArgs;

class ArtifactRepository extends BasicRepository<ArtifactResource, ArtifactResource, ArtifactListArgs> {
    constructor(client: Client) {
        super("Artifacts", client);
    }
}

export default ArtifactRepository;
